import "./Gallery.css"

function Gallery(){
    return (
        <>        
            <div className="gallery-containter">

                <br></br>
                <br></br>
                <br></br>
                <h2 style={{color:'darkcyan'}}>🐳Gallery🐳</h2>
                <Card
                    사진="/img/망그러진곰.png"
                    제목="망그러진 곰"
                    설명="귀엽다" />
                <Card
                    사진="/img/곽철이.png"
                    제목="곽철이"
                    설명="이름이 귀엽다" />
                <Card
                    사진="/img/바덕이.png"
                    제목="바덕이"
                    설명="바나나 오리" />
                <Card
                    사진="/img/오둥이.png"
                    제목="오둥이"
                    설명="얘도 오리" />
                <Card
                    사진="/img/부실감자.png"
                    제목="부실감자"
                    설명="개강이 싫은 부실감자" />
                <Card
                    사진="/img/왈맹이.png"
                    제목="왈맹이"
                    설명="힘없어서 귀엽다" />
                <Card
                    사진="/img/작은 회색 고양이.png"
                    제목="작은 회색 고양이"
                    설명="못생김" />
                <Card
                    사진="/img/잔망루피.png"
                    제목="잔망 루피"
                    설명="귀여웡" /> 
            </div>
        </>
    )
}

function Card({사진, 제목, 설명}) {
    return (
        <div className="picture-card">
            <img src={process.env.PUBLIC_URL + 사진} alt={제목}/>
            <h4 style={{color:'black'}} >{제목}</h4>
            <p style={{color:'seagreen'}}>{설명}</p>
        </div>
    );
}

export default Gallery;
